import { render } from "./ProdDiaIndex.vue?vue&type=template&id=f9978752"
import script from "./ProdDiaIndex.vue?vue&type=script&lang=js"
export * from "./ProdDiaIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/produccion/ProdDiaIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f9978752"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f9978752', __exports__)) {
    api.reload('f9978752', __exports__)
  }
  
  module.hot.accept("./ProdDiaIndex.vue?vue&type=template&id=f9978752", () => {
    api.rerender('f9978752', render)
  })

}


export default __exports__